import { useState, type FormEvent } from 'react';
import { ApiError } from '../../../api/client';
import { publico } from '../../../api/publico';
import { Enlace } from '../../../router';
import { AvisoError, Boton, EstadoVacio, Entrada, Marco } from '../../../ui';
import { useFormulario } from '../../../forms/useFormulario';
import { LARGOS, validarEmail } from '../../../forms/validacion';

export function Recuperar() {
  const [enviado, setEnviado] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const formulario = useFormulario({ email: '' }, { email: validarEmail }, { email: LARGOS.email });

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    if (!formulario.validarTodo()) return;
    setEnviando(true);
    try {
      const { mensaje } = await publico.recuperar(formulario.valores.email.trim());
      setEnviado(mensaje);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'No pudimos enviar el pedido. Probá de nuevo en un momento.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Marco titulo="Recuperar el acceso" pie={<Enlace a="/login">Volver a ingresar</Enlace>}>
      {enviado ? (
        <EstadoVacio icono="mail" titulo="Revisá tu correo" cuerpo={enviado} />
      ) : (
        <form onSubmit={(e) => void enviar(e)} noValidate className="acceso__formulario">
          <p className="acceso__nota">Escribí el correo con el que te registraste y te mandamos un enlace para crear una contraseña nueva.</p>
          <AvisoError>{error}</AvisoError>
          <Entrada etiqueta="Correo electrónico" type="email" autoComplete="email" required {...formulario.campo('email')} />
          <Boton type="submit" tamano="grande" anchoCompleto cargando={enviando}>Enviarme el enlace</Boton>
        </form>
      )}
    </Marco>
  );
}
